export const NOOP = () => { };
export const safeParse = (str, defaultVal = str, onerror = NOOP) => {
    if (typeof str !== 'string') {
        return str;
    }
    try {
        /* eslint-disable-next-line code-spec-unid/no-json-parse-or-json-stringify */
        return JSON.parse(str);
    }
    catch (e) {
        onerror(e);
        return defaultVal;
    }
};
